// @flow

import {
  GetReportingParameters,
  GetReportingParametersSuccess,
  GetReportingParametersError,
  UpdateReportingParameters,
  UpdateReportingParametersSuccess,
  UpdateReportingParametersError,
  GetReportingParametersSchema,
  GetReportingParametersSchemaSuccess,
  GetReportingParametersSchemaError,
  GetReasonsToBeExcluded,
  GetReasonsToBeExcludedSuccess,
  GetReasonsToBeExcludedError,
  GetReasonsToBeExcludedSchema,
  GetReasonsToBeExcludedSchemaSuccess,
  GetReasonsToBeExcludedSchemaError,
  ToggleReasonsToBeExcludedModal,
  SetEditReasonToBeExcluded,
  CreateReasonToBeExcluded,
  CreateReasonToBeExcludedSuccess,
  CreateReasonToBeExcludedError,
  UpdateReasonToBeExcluded,
  UpdateReasonToBeExcludedSuccess,
  UpdateReasonToBeExcludedError,
  DeleteReasonToBeExcluded,
  DeleteReasonToBeExcludedSuccess,
  DeleteReasonToBeExcludedError,
  ToggleDeleteReasonToBeExcludedConfirmModal,
  ToggleScheduledReportsWarningModal,
} from "@modules/service/constants/actions";

import { cloneObject } from "@utils/object";
import * as reportingParametersReducers from "./reducers";
import initialState from "./state";
import type { ReportingParametersState } from "./types";

export default (state: ReportingParametersState = initialState, action: Object) => {
  const act = {
    [GetReportingParameters]: reportingParametersReducers.setLoading,
    [GetReportingParametersSuccess]: reportingParametersReducers.onGetReportingParametersSuccess,
    [GetReportingParametersError]: reportingParametersReducers.onGetReportingParametersError,
    [UpdateReportingParameters]: reportingParametersReducers.setLoading,
    [UpdateReportingParametersSuccess]:
      reportingParametersReducers.onUpdateReportingParametersSuccess,
    [UpdateReportingParametersError]: reportingParametersReducers.onError,
    [GetReportingParametersSchema]: reportingParametersReducers.setLoading,
    [GetReportingParametersSchemaSuccess]:
      reportingParametersReducers.onGetReportingParametersSchemaSuccess,
    [GetReportingParametersSchemaError]: reportingParametersReducers.onError,
    [GetReasonsToBeExcluded]: reportingParametersReducers.setLoading,
    [GetReasonsToBeExcludedSuccess]: reportingParametersReducers.onGetReasonsToBeExcludedSuccess,
    [GetReasonsToBeExcludedError]: reportingParametersReducers.onError,
    [CreateReasonToBeExcluded]: reportingParametersReducers.setLoading,
    [CreateReasonToBeExcludedSuccess]: reportingParametersReducers.stopLoading,
    [CreateReasonToBeExcludedError]: reportingParametersReducers.onError,
    [UpdateReasonToBeExcluded]: reportingParametersReducers.setLoading,
    [UpdateReasonToBeExcludedSuccess]: reportingParametersReducers.stopLoading,
    [UpdateReasonToBeExcludedError]: reportingParametersReducers.onError,
    [DeleteReasonToBeExcluded]: reportingParametersReducers.setLoading,
    [DeleteReasonToBeExcludedSuccess]: reportingParametersReducers.stopLoading,
    [DeleteReasonToBeExcludedError]: reportingParametersReducers.onError,
    [GetReasonsToBeExcludedSchema]: reportingParametersReducers.setLoading,
    [GetReasonsToBeExcludedSchemaSuccess]:
      reportingParametersReducers.onGetReasonsToBeExcludedSchemaSuccess,
    [GetReasonsToBeExcludedSchemaError]: reportingParametersReducers.onError,
    [ToggleReasonsToBeExcludedModal]: reportingParametersReducers.onToggleReasonsToBeExcludedModal,
    [ToggleDeleteReasonToBeExcludedConfirmModal]:
      reportingParametersReducers.onToggleDeleteReasonToBeExcludedConfirmModal,
    [SetEditReasonToBeExcluded]: reportingParametersReducers.onSetEditReasonToBeExcluded,
    [ToggleScheduledReportsWarningModal]:
      reportingParametersReducers.onToggleScheduledReportsWarningModal,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
